import { Component, OnInit } from '@angular/core';
import { OrganizationConfig } from '../../../../../../models/organization-config';
import { AccountService } from '../../../../../../services/account/account.service';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-membership-freeze-reason-settings',
  templateUrl: './membership-freeze-reason-settings.component.html',
  styleUrls: ['./membership-freeze-reason-settings.component.css']
})
export class MembershipFreezeReasonSettingsComponent implements OnInit {

  public orgConfig: OrganizationConfig;
  public reasonOptionsInput = '';
  public reasonOptionsInputNumRows = 6;

  public loadingOrgConfig = true;
  public loadingSave = false;

  public successMessage = '';
  public errorMessage = '';
  public errors: any = {};
  public serverError: number = null;

  constructor(
    private accountService: AccountService,
    private orgConfigService: OrganizationConfigService
  ) {}

  ngOnInit() {
    this.loadOrganizationConfig();
  }

  /**
   * Load the organization config from the API.
   *
   * We do not use the local-stored copy, in order to avoid pop-in of changed
   * values.
   */
  public loadOrganizationConfig() {
    this.loadingOrgConfig = true;

    this.orgConfigService
      .loadOrganizationConfig()
      .then(() => {
        this.orgConfig = this.orgConfigService.getOrganizationConfig();
        this.reasonOptionsInput = '';
        for (const reasonOption of this.orgConfig.membership_freeze_reason_options) {
          this.reasonOptionsInput += reasonOption + '\n';
        }
        this.reasonOptionsInputNumRows = this.orgConfig.membership_freeze_reason_options.length + 1;

        const orgConfigServerError = this.orgConfigService.getOrganizationConfigServerError();
        if (orgConfigServerError) {
          this.serverError = orgConfigServerError;
        }
        this.loadingOrgConfig = false;
      });
  }

  public handleSave() {
    this.loadingSave = true;

    this.errors = {};
    this.errorMessage = '';

    this.orgConfig.membership_freeze_reason_options = [];
    for (let reasonOption of this.reasonOptionsInput.split(/[\r\n]+/)) {
      reasonOption = reasonOption.trim();
      if (reasonOption.length > 0) {
        this.orgConfig.membership_freeze_reason_options.push(reasonOption);
      }
    }

    this.orgConfigService
      .updateOrgConfig({
        require_membership_freeze_reason: this.orgConfig.require_membership_freeze_reason,
        membership_freeze_reason_options: this.orgConfig.membership_freeze_reason_options
      })
      .then(updatedOrgConf => {
        this.orgConfig = updatedOrgConf;
        this.successMessage = 'Settings updated successfully.';
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to modify these settings.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

}
